<template>
  <div class="login">
    <img class="login_title" src="../assets/login_title.png" alt="" />
    <p class="wel_use">欢迎使用沃要省钱</p>
    <div class="tel">
      <input
        type="text"
        v-model="tel"
        @input="telChange"
        placeholder="请输入手机号"
      />
      <span class="sendCode" v-if="isSendCode"  @click="sendCode">发送验证码</span>
 <span class="sendCode2" v-else >验证码已发送</span>
     

    </div>
    <div class="yzm">
      <input
        type="text"
        v-model="patt"
        @input="pattChange"
        placeholder="验证码"
      />
      <img
        class="login_btn"
        @click="loginBtn"
        src="../assets/login_btn.png"
        alt=""
      />
      <!-- <button class="login_btn">立即登录</button> -->
    </div>
  </div>
</template>

<script>
import { tool } from "../utils";
let timer;
export default {
  data() {
    return {
      tel: "", //手机号
      patt: "", //验证码
      time: 60, //倒计时
      isSendCode: true, //是否发送验证码
      code: "",
    };
  },

  created() {
    var that = this;

    if (!localStorage.getItem("sourceType")) {
      localStorage.setItem("sourceType", that.$route.query.sourceType);
    } else {
      if (that.$route.query.sourceType) {
        localStorage.setItem("sourceType", that.$route.query.sourceType);
      } else {
        console.log(2222);
      }
    }

    that.code = that.$route.query.code;
    // 获取微信信息
    if (!localStorage.getItem("openid")) {
      if (this.$route.query.code) {
        console.log('code',that.code, localStorage.getItem("sourceType"))
        that.http
          .getOpenId({
            code: that.code,
            sourceType: localStorage.getItem("sourceType"),
          })
          .then((res) => {
            console.log(res.data);
            localStorage.setItem("userId", res.data.data.user.id);
            localStorage.setItem("headimgurl", res.data.data.user.headimgurl);
            localStorage.setItem("openid", res.data.data.user.openid);
            localStorage.setItem("nickName", res.data.data.user.nickName);
            if(res.data.data.user.phone){
            localStorage.setItem("phone", res.data.data.user.phone);

               this.$router.replace({
                path: "/home",
                query: {},
              });
            }else{
                this.$router.replace({
                path: "/login",
                query: {},
              });
            }
          });
      } else {
        var redirectUri = window.location.href;
        window.location.href =
          "http://wxpay.aizhishifm.com/code.html?reqUrl=" +
          encodeURIComponent("https://sqzs.aizhishifm.cn/server/member/getCode") +
          "&backUrl=" +
          encodeURIComponent(redirectUri);
      }
    }else{
      if(localStorage.getItem('phone')){
         this.$router.replace({
                path: "/home",
                query: {},
              });
      }else{
         this.$router.replace({
                path: "/login",
                query: {},
              });
      }
    }
  },
  methods: {
    // 手机号
    telChange(e) {
      this.tel = e.target.value;
    },
    // 验证码
    pattChange(e) {
      this.patt = e.target.value;
      console.log(e.target.value);
    },

    // 发送验证码
    sendCode() {
      tool.clickDelay("sendCode", 2300);
      let patt = /^(0|86|17951)?(13[0-9]|15[012356789]|16[6]|19[89]]|17[01345678]|18[0-9]|14[579])[0-9]{8}$/;
      let phone = this.tel;
      console.log("phone", phone);
      if (this.tel) {
        if (patt.test(phone)) {
          this.http
            .getCheckCode({
              phone: phone,
            })
            .then((res) => {
              if (res.data.code == 400) {
                this.$alert("您为非会员，将为您跳转到订购页", "", {
                  confirmButtonText: "确定",
                  showClose: false,
                  callback: (action) => {
                    location.href = "https://www.baidu.com";
                  },
                });
              } else if (res.data.code == 200) {
                this.isSendCode = false;
                
                timer = setInterval(() => {
                  this.time = this.time - 1;
                  if (this.time === 0) {
                    clearInterval(timer);
                    // this.text = "重新发送验证码";
                    this.isSendCode = true;
                    this.time = 60;
                  }
                }, 1000);
              } else {
                this.$message.error(res.data.message);
              }
            });
        } else {
          this.$message({
            showClose: true,
            message: "手机号格式不正确",
            type: "error",
            duration: 2000,
          });
        }
      } else {
         this.$message({
            showClose: true,
            message: "手机号不能为空",
            type: "error",
            duration: 2000,
          });
       
      }
    },

    // 立即登录
    loginBtn() {
      tool.clickDelay("login_btn", 2300);
      console.log(this.tel,this.patt)
      if (this.tel && this.patt) {
        // 发送请求
        this.http
          .checkCode({
            phone: this.tel,
            code: this.patt,
            openId:localStorage.getItem('openid')
          })
          .then((res) => {
            console.log(res, "立即登录");
            if (res.data.code == 200) {
            localStorage.setItem("phone",this.tel);

              this.$router.replace({
                path: "/home",
                query: {},
              });
            } else {
              this.$message.error(res.data.message);
            }
          });
      } else {
         this.$message({
            showClose: true,
            message: "手机号或验证码不能为空",
            type: "error",
            duration: 2000,
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  padding: 2.3rem 0 0 0.5rem;
  input {
    border-radius: 0.08rem;
  }
  .login_title {
    margin-left: -0.1rem;
    width: 2.3rem;
    height: 0.68rem;
  }
  .wel_use {
    margin-top: 0.3rem;
    text-align: left;
    font-size: 0.3rem;
  }
  .tel {
    margin-top: 0.5rem;
    width: 6.41rem;
    height: 0.81rem;
    position: relative;
    input {
      text-indent: 1em;
      width: 100%;
      height: 100%;
    }
    span {
      height: 100%;
      line-height: 0.81rem;
      display: inline-block;
      font-size: 0.28rem;
      font-weight: bold;
      color: #f5cf4c;
      position: absolute;
      right: 0.3rem;
    }
  }
  .yzm {
    width: 6.41rem;
    height: 0.81rem;
    display: flex;
    justify-content: space-between;
    margin-top: 0.3rem;
    input {
      text-indent: 1em;
      width: 2.04rem;
      height: 0.81rem;
    }
    .login_btn {
      font-weight: bold;
      border-radius: 0.08rem;
      width: 4.07rem;
      height: 0.81rem;
      background-color: #f5cf4c;
    }
  }
}
</style>
